import React from 'react';
import withLogin from '@hipagesgroup/with-login';
import HeaderRender, { HeaderProps } from './presentational';
import Search from './search';

const HeaderBase: React.FC<HeaderProps> = props => (
  <HeaderRender {...props}>
    <Search {...props} />
  </HeaderRender>
);

const Header = withLogin(HeaderBase);

export { default as HeaderSimple } from './SimpleHeader';
export default Header;
